import { render, staticRenderFns } from "./SearchOverlay.vue?vue&type=template&id=b27e658a&scoped=true"
import script from "./SearchOverlay.vue?vue&type=script&lang=js"
export * from "./SearchOverlay.vue?vue&type=script&lang=js"
import style0 from "./SearchOverlay.vue?vue&type=style&index=0&id=b27e658a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27e658a",
  null
  
)

export default component.exports